import './_go-to-top.scss';

//Init ScrollToTop component and enable better accessibility features.

export default function GoToTop() {
    const $goToTop = document.querySelector('.go-to-top') as HTMLDivElement;
    const $header = document.querySelector('.header') as HTMLElement;

    if ($goToTop) {
        const $btn = $goToTop.querySelector('a') as HTMLElement;
        $goToTop.classList.remove('visible');

        if ($header) {
            window.addEventListener('scroll', () => {
                if ($header.classList.contains('sticky-desktop') && window.innerWidth > 991 || $header.classList.contains('sticky-mobile') && window.innerWidth < 991) {
                    $goToTop.classList.add('visible');
                    $btn.style.top = String(window.innerHeight - 80) + 'px';
                } else {
                    $goToTop.classList.remove('visible');
                }
            });
        }

        function scrollToTop() {
            document.body.scrollIntoView({
                behavior: 'smooth',
            });
        }

        $btn.addEventListener('click', () => scrollToTop());
        $btn.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                scrollToTop();
            }
        });
    }
}
